import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import Footer from "@/components/Footer";
import ToolEmbed from "@/components/ToolEmbed";
import { getFeaturedTools } from "@/data/tools";
import { useLanguage } from "@/context/LanguageContext";
import SEO from "@/components/SEO";
import Breadcrumbs from "@/components/Breadcrumbs";

const FreeTools = () => {
  const featuredTools = getFeaturedTools();
  const { t } = useLanguage();
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Add a small delay to ensure DOM is fully rendered
      const timeoutId = setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 500);

      return () => clearTimeout(timeoutId);
    }
  }, [hash]);

  return (
    <main id="main-content" className="min-h-screen">
      <SEO
        title={t("seo.freetools.title")}
        description={t("seo.freetools.description")}
        keywords={t("seo.freetools.keywords").split(",").map((k) => k.trim())}
      />
      <div className="container mx-auto px-2 sm:px-4 py-12">
        <Breadcrumbs />


        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 animate-fade-in">
            {t('tools.heading')}
          </h1>
          <p className="text-xl text-gray-300 mb-12 animate-fade-in" style={{ animationDelay: "100ms" }}>
            {t('tools.description')}
          </p>

          <div className="space-y-8">
            {/* Work in Progress */}
            <div className="mt-12 p-6 border border-warning/30 rounded-lg bg-warning/5 backdrop-blur-sm animate-fade-in" style={{ animationDelay: "100ms" }}>
              <h3 className="text-lg font-semibold mb-3 text-warning-foreground">{t('tools.wip.title')}</h3>
              <p className="text-sm text-gray-300 leading-relaxed">
                {t('tools.wip.description')}
              </p>
            </div>

            {/* Featured Tools */}
            {featuredTools.length > 0 && (
              <div className="space-y-6">
                <div className="grid gap-6">
                  {featuredTools.map((tool) => (
                    <div id={tool.id} key={tool.id} className="scroll-mt-24">
                      <ToolEmbed
                        toolId={tool.id}
                        sections={['overview', 'features', 'screenshots', 'contribution']}
                        showHeader={true}
                        showActions={true}
                        className="animate-scale-in"
                        style={{ animationDelay: `${200 + featuredTools.indexOf(tool) * 100}ms` }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}

          </div>
        </div>
      </div>
      <Footer />
    </main>
  );
};

export default FreeTools;
